"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToTs = void 0;
function dateToTs(date) {
    return Date.parse(date) / 1000;
}
exports.dateToTs = dateToTs;
//# sourceMappingURL=date-time.js.map